(() => {
  // index.html url 参数初始化处理逻辑
  function isJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (error) {
      return false;
    }
  }
  // 进入时间戳
  window.dateNow = Date.now();
  // console.log("========window.dateNow========", window.dateNow)

  // app端异步调用此函数，发送邀请码
  // console.log('0809-index初始化')
  window.sendMessageToWeb = function (e) {
    console.log("0819-sendMessageToWeb执行", typeof e === "object", e);
    if (e && typeof e === "object") {
      if (e.key === "uid" && e.value) {
        if (!window.localStorage.getItem("inviteCode")) {
          window.localStorage.setItem("inviteCode", JSON.stringify(e.value));
        }
      } else if (e.key === "uid" && e.value) {
        let obj = {};
        if (isJSON(e.value)) {
          obj = JSON.parse(e.value);
        } else {
          obj = e.value;
        }
        let isFromApp = false;
        if (obj.ft) {
          const ft = obj.ft.toLowerCase();
          isFromApp = ft === "ios" || ft === "android";
        }
        if (isFromApp) {
          window.localStorage.setItem("isFromApp", isFromApp);
          window.localStorage.setItem("initQuery", JSON.stringify(obj));
        }
        if (obj.hideTopDownload || obj.device_id) {
          window.localStorage.setItem("hideTopDownload", JSON.stringify(true));
          if (typeof window.sendMessageToWebhideTopDownload() === "function") {
            window.sendMessageToWebhideTopDownload();
          }
        }
      } else if (e.key === "native_init" && e.value) {
        let obj1 = {};
        if (isJSON(e.value)) {
          obj1 = JSON.parse(e.value);
        } else {
          obj1 = e.value;
        }
        if (obj1.fcm_register_token) {
          window.localStorage.setItem(
            "fcmRegisterToken",
            JSON.stringify(obj1.fcm_register_token)
          );
        }
      } else if (e.key === "native_notice" && e.value) {
        let obj2 = {};
        if (isJSON(e.value)) {
          obj2 = JSON.parse(e.value);
        } else {
          obj2 = e.value;
        }
        if (obj2.notice_launch && obj2.msg_sid) {
          window.localStorage.setItem(
            "noticeLaunch",
            JSON.stringify({
              notice_launch: obj2.notice_launch,
              msg_sid: obj2.msg_sid,
            })
          );
        }
      }
    }
  };

  function getUrlkey() {
    const geturl = window.location.href;
    let getqyinfo = geturl.split("?")[1];
    if (getqyinfo) {
      const index = getqyinfo.indexOf("#/");
      if (index !== -1) {
        getqyinfo = getqyinfo.slice(0, index);
      }
    }
    const obj = {}; // 创建空对象，接收截取的参数
    if (getqyinfo) {
      const getqys = getqyinfo.split("&");
      const isSpecial = {};
      for (let i = 0; i < getqys.length; i++) {
        const item = getqys[i].split("=");
        const key = item[0];
        const value = item[1];
        if (value === "undefined" || value === "null") {
          continue;
        }
        obj[key] = value;
      }
    }
    return obj;
  }

  // device_id	         string	       必须        设备id
  // ft	                 string	       必须        来源类型  android | ios | tg
  // goto	               string	       非必须      来源为tg时 吊起 recharge withdraw
  // uid	               string	       非必须      邀请码
  // hideTopDownload	   string	       非必须      隐藏头部下载按钮（传了device_id可不传同样会隐藏）
  const initQuery = getUrlkey();
  if (initQuery.install_id) {
    localStorage.setItem("install_id", initQuery.install_id);
  }
  // console.log('0809-initQuery', initQuery)
  if (initQuery.skmode === "true") {
    localStorage.setItem("skmode", true);
  }
  let isFromApp = false;
  // 来源类型
  if (initQuery.ft) {
    const ft = initQuery.ft.toLowerCase();
    isFromApp = ft === "ios" || ft === "android";
    // 马甲包
    if (isFromApp) {
      window.localStorage.setItem("isFromApp", isFromApp);
    }
    window.localStorage.setItem("initQuery", JSON.stringify(initQuery));
    // tg
    if (ft === "tg") {
      window.localStorage.removeItem("Admin-Token");
      window.localStorage.removeItem("IS_LOGIN");
    }
  }
  const tginitQuery =
    JSON.parse(window.localStorage.getItem("initQuery")) || {};
  // console.log(tginitQuery.ft ,'333333333333333333')
  if (tginitQuery.ft == "tg") {
    window._isTG = true;
    const s1 = document.createElement("script");
    s1.src = "/static/telegram-web-app.js?a=2";
    s1.async = true;
    // 监听加载完成
    s1.onload = function () {
      if (window.Telegram && window.Telegram.WebApp) {
        //  console.log('Telegram SDK loaded');

        try {
          window.Telegram.WebApp.ready();
          window.Telegram.WebApp.expand();
          window.Telegram.WebApp.enableClosingConfirmation();
          window.Telegram.WebApp.requestFullscreen();
          window.Telegram.WebApp.disableVerticalSwipes();
          // 'android'/'ios 平台重置变量
          if (["android", "ios"].includes(window.Telegram.WebApp.platform)) {
            // Telegram.WebApp.expand();
            // Telegram.WebApp.requestFullscreen();
          }
        } catch (error) {}
        // Telegram.WebApp.expand(); // 扩展全屏
        // Telegram.WebApp.setBackgroundColor('#0d131c'); // 设置背景颜色为橙色
      }
    };
    const node = document.getElementsByTagName("script")[0];
    node.parentNode.insertBefore(s1, node);
  }
  // console.log(isFromApp ,'isFromApp')
  // if (initQuery) {
  //   window.localStorage.setItem(
  //     "localInitQuery",
  //     JSON.stringify(Object.assign(initQuery))
  //   ) || {};
  // }
  // 三方马甲包 af上报 androidview=1
  ThirdPartySubmissionStorage(initQuery);
  if (initQuery.androidview) {
    window.localStorage.setItem(
      "AFAndroidview",
      JSON.stringify(initQuery.androidview)
    );
  }
  // if (initQuery.uid) {
  //   window.localStorage.setItem("inviteCode", JSON.stringify(initQuery.uid));
  // }
  //  推广sid
  // if (initQuery.sid) {
  //   const promoteSid = initQuery.sid.split("_")[0];
  //   window.localStorage.setItem("promoteSid", promoteSid);
  // }
  // 快手 来源
  // if (initQuery.click_id && initQuery.pixel_id) {
  //   const obj = {
  //     click_id: decodeURIComponent(initQuery.click_id),
  //     pixel_id: decodeURIComponent(initQuery.pixel_id),
  //   };
  //   window.localStorage.setItem("kwai_obj", JSON.stringify(obj));
  //   window.localStorage.removeItem("ttclid");
  //   window.localStorage.removeItem("fbclid");
  //   window.localStorage.removeItem("visitor_id");
  //   window.localStorage.removeItem("appsflyer_id");
  // }
  // // tiktok 来源
  // if (initQuery.ttclid) {
  //   window.localStorage.setItem("ttclid", JSON.stringify(initQuery.ttclid));
  //   window.localStorage.removeItem("kwai_obj");
  //   window.localStorage.removeItem("fbclid");
  //   window.localStorage.removeItem("visitor_id");
  //   window.localStorage.removeItem("appsflyer_id");
  // }
  // // fb 来源
  // if (initQuery.fbclid) {
  //   window.localStorage.setItem("fbclid", JSON.stringify(initQuery.fbclid));
  //   if (initQuery.pixel_id) {
  //     window.localStorage.setItem(
  //       "fb_pixel_id",
  //       JSON.stringify(initQuery.pixel_id)
  //     );
  //   }
  //   window.localStorage.removeItem("kwai_obj");
  //   window.localStorage.removeItem("ttclid");
  //   window.localStorage.removeItem("visitor_id");
  //   window.localStorage.removeItem("appsflyer_id");
  // }
  // // PropellerAds来源 visitor_id
  // if (initQuery.visitor_id) {
  //   window.localStorage.setItem(
  //     "visitor_id",
  //     JSON.stringify(initQuery.visitor_id)
  //   );
  //   window.localStorage.removeItem("kwai_obj");
  //   window.localStorage.removeItem("ttclid");
  //   window.localStorage.removeItem("fbclid");
  //   window.localStorage.removeItem("appsflyer_id");
  // }
  if (initQuery.hideTopDownload || initQuery.device_id) {
    window.localStorage.setItem("hideTopDownload", JSON.stringify(true));
  }
  console.log(initQuery.rc);

  // af来源
  // if (initQuery && initQuery.appsflyer_id) {
  //   window.localStorage.setItem(
  //     "appsflyer_id",
  //     JSON.stringify({
  //       appsflyer_id: initQuery.appsflyer_id,
  //       app_id: initQuery.app_id || "",
  //     })
  //   );
  //   window.localStorage.removeItem("kwai_obj");
  //   window.localStorage.removeItem("ttclid");
  //   window.localStorage.removeItem("fbclid");
  //   window.localStorage.removeItem("visitor_id");
  // }

  // 兑换码rc
  if (initQuery.rc) {
    window.sessionStorage.setItem("REDEEM_CODE", initQuery.rc);
  }
  // 终端类型 1、lightweight、2、pwa、3、shortcut、4、normal
  let terminaltype = "";
  if (isFromApp) {
    terminaltype = "vestpackage";
  }
  // console.log(initQuery.terminaltype ,'initQuery.terminaltype')
  if (
    ["pwa", "lightweight", "shortcut", "tg", "normal"].includes(
      initQuery.terminaltype
    )
  ) {
    terminaltype = initQuery.terminaltype;
  } else if (window._isTG) {
    terminaltype = "tg";
  }
  if (terminaltype) {
    window.localStorage.setItem("terminaltype", terminaltype);
  }

  if (initQuery.notice_launch) {
    window.localStorage.setItem(
      "noticeLaunch",
      JSON.stringify({
        notice_launch: initQuery.notice_launch,
        msg_sid: initQuery.msg_sid || "",
      })
    );
  }

  if (initQuery && initQuery.light) {
    window.localStorage.setItem("isLight", true);
  }
  // fb 创建的账号url进入
  if (initQuery && initQuery.uniqueId) {
    window.localStorage.setItem("uniqueId", initQuery.uniqueId);
  }

  // 获取轻量包params参数 设置全屏
  const isLight = window.localStorage.getItem("isLight");
  if (isLight) {
    const linkElement = document.createElement("link");
    linkElement.rel = "manifest";
    linkElement.href = "/manifest.json";
    document.head.appendChild(linkElement);
  }
})();

export function ThirdPartySubmissionStorage(initQuery) {
  // console.log(initQuery, "initQueryqqqqqqqqqqqqqqqqqqqq");
  // console.log(isFromApp ,'isFromApp')
  try {
    if (initQuery) {
      window.localStorage.setItem(
        "localInitQuery",
        JSON.stringify(Object.assign(initQuery))
      ) || {};
    }
    if (initQuery.uid) {
      window.localStorage.setItem("inviteCode", JSON.stringify(initQuery.uid));
    }

    //  推广sid
    if (initQuery.sid) {
      const promoteSid = initQuery.sid.split("_")[0];
      window.localStorage.setItem("promoteSid", promoteSid);
    }
    // 快手 来源
    if (initQuery.click_id && initQuery.pixel_id) {
      const obj = {
        click_id: decodeURIComponent(initQuery.click_id),
        pixel_id: decodeURIComponent(initQuery.pixel_id),
      };
      window.localStorage.setItem("kwai_obj", JSON.stringify(obj));
      window.localStorage.removeItem("ttclid");
      window.localStorage.removeItem("fbclid");
      window.localStorage.removeItem("visitor_id");
      window.localStorage.removeItem("appsflyer_id");
      localStorage.setItem(
        "urlParams",
        initQuery?.adsCustomParams || JSON.stringify(initQuery)
      );
    }
    // tiktok 来源
    if (initQuery.ttclid) {
      window.localStorage.setItem("ttclid", JSON.stringify(initQuery.ttclid));
      window.localStorage.removeItem("kwai_obj");
      window.localStorage.removeItem("fbclid");
      window.localStorage.removeItem("visitor_id");
      window.localStorage.removeItem("appsflyer_id");
      localStorage.setItem(
        "urlParams",
        initQuery?.adsCustomParams || JSON.stringify(initQuery)
      );
    }
    // fb 来源
    if (initQuery.fbclid && (initQuery.utm_id || initQuery.utm_campaign)) {
      window.localStorage.setItem("fbclid", JSON.stringify(initQuery.fbclid));
      if (initQuery.pixel_id) {
        window.localStorage.setItem(
          "fb_pixel_id",
          JSON.stringify(initQuery.pixel_id)
        );
      }
      window.localStorage.removeItem("kwai_obj");
      window.localStorage.removeItem("ttclid");
      window.localStorage.removeItem("visitor_id");
      window.localStorage.removeItem("appsflyer_id");
      localStorage.setItem(
        "urlParams",
        initQuery?.adsCustomParams || JSON.stringify(initQuery)
      );
    }
    // PropellerAds来源 visitor_id
    if (initQuery.visitor_id) {
      window.localStorage.setItem(
        "visitor_id",
        JSON.stringify(initQuery.visitor_id)
      );
      window.localStorage.removeItem("kwai_obj");
      window.localStorage.removeItem("ttclid");
      window.localStorage.removeItem("fbclid");
      window.localStorage.removeItem("appsflyer_id");
      localStorage.setItem(
        "urlParams",
        initQuery?.adsCustomParams || JSON.stringify(initQuery)
      );
    }
    if (initQuery.hideTopDownload || initQuery.device_id) {
      window.localStorage.setItem("hideTopDownload", JSON.stringify(true));
    }
    console.log(initQuery.rc);

    // af来源
    if (initQuery && initQuery.appsflyer_id) {
      window.localStorage.setItem(
        "appsflyer_id",
        JSON.stringify({
          appsflyer_id: initQuery.appsflyer_id,
          app_id: initQuery.app_id || "",
        })
      );
      window.localStorage.removeItem("kwai_obj");
      window.localStorage.removeItem("ttclid");
      window.localStorage.removeItem("fbclid");
      window.localStorage.removeItem("visitor_id");
      localStorage.setItem(
        "urlParams",
        initQuery?.adsCustomParams || JSON.stringify(initQuery)
      );
    }
  } catch (error) {
    console.log(error);
  }
}
